import React from 'react';

const tone = (s) => (s >= 75 ? '#1F7A4D' : s >= 50 ? '#C9A227' : '#B4452F');

/* Anello voto 0-100 */
export const ScoreRing = ({ score = 0, size = 76, testid = 'coach-score-ring' }) => {
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(0,0,0,0.08)" strokeWidth="7" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} stroke={tone(score)} strokeWidth="7" fill="none"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: 'stroke-dashoffset 900ms ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-serif text-2xl leading-none" style={{ color: tone(score) }}>{score}</span>
        <span className="text-[9px] uppercase tracking-widest text-muted-foreground">/100</span>
      </div>
    </div>
  );
};

export const ScorePill = ({ score }) => (
  <span
    className="inline-flex items-center justify-center min-w-[2.4rem] px-2 py-0.5 rounded-full text-xs font-semibold text-white"
    style={{ background: score == null ? '#9CA3AF' : tone(score) }}
    data-testid="coach-score-pill"
  >
    {score == null ? '—' : score}
  </span>
);

const LABELS = {
  rapport: 'Rapport', certezza_prodotto: 'Certezza prodotto', certezza_azienda: 'Certezza azienda',
  certezza_venditore: 'Certezza venditore', controllo_e_tonalita: 'Controllo e tonalità',
  gestione_obiezioni: 'Gestione obiezioni', chiusura: 'Chiusura',
};

/* Barre Straight Line 0-10 */
export const StraightLineBars = ({ data = {} }) => (
  <div className="space-y-1.5" data-testid="coach-straight-line">
    {Object.entries(data).map(([k, v]) => (
      <div key={k} className="flex items-center gap-2 text-xs">
        <span className="w-36 shrink-0 text-muted-foreground">{LABELS[k] || k.replace(/_/g, ' ')}</span>
        <div className="flex-1 h-2 rounded-full bg-black/5 overflow-hidden">
          <div className="h-full rounded-full" style={{ width: `${v * 10}%`, background: tone(v * 10), transition: 'width 700ms ease' }} />
        </div>
        <span className="w-5 text-right tabular-nums">{v}</span>
      </div>
    ))}
  </div>
);
